import { createContext } from 'react';

import { MenuItem } from '@/components/layout/sidebar/SidebarMenuItems';

const SidebarMenuItemsContext = createContext<MenuItem[]>([]);

export default SidebarMenuItemsContext;
